<template>
  <div class="v-container">
    <div class="loadding-spin" v-if="loading">
      <Circle4></Circle4>
    </div>
    <div class="card">
      <div class="card-header">
        <h3 v-if="mData.viewMode === 'create'">THÊM MỚI THÔNG BÁO</h3>
        <h3 v-if="mData.viewMode === 'detail'">CHI TIẾT THÔNG BÁO</h3>
        <h3 v-if="mData.viewMode === 'update'">CẬP NHẬT THÔNG BÁO</h3>
      </div>

      <div class="card-body">
        <el-form
          :model="mData.dataForm"
          :rules="mData.validForm"
          ref="myForm"
          label-position="top"
        >
          <b-row>
            <b-col lg="6">
              <el-form-item label="Tiêu đề" prop="title">
                <el-input
                  v-model="mData.dataForm.title"
                  :disabled="mData.viewMode == 'detail'"
                  maxlength="60"
                  clearable
                  placeholder="Tối đa không quá 60 ký tự"
                  tabindex="1"
                ></el-input>
              </el-form-item>
              <el-form-item label="Nội dung tin nhắn" prop="message">
                <el-input
                  type="textarea"
                  :autosize="{ minRows: 10, maxRows: 99 }"
                  v-model="mData.dataForm.message"
                  :disabled="mData.viewMode == 'detail'"
                  tabindex="3"
                ></el-input>
              </el-form-item>
              <el-form-item label="Thời điểm gửi" prop="schedule">
                <el-date-picker
                  v-model="mData.dataForm.schedule"
                  type="datetime"
                  format="dd/MM/yyyy HH:mm:ss"
                  :disabled="mData.viewMode == 'detail'"
                  @input="$forceUpdate()"
                  tabindex="4"
                >
                </el-date-picker>
              </el-form-item>
            </b-col>
            <b-col lg="6">
              <el-form-item label="Tên dòng họ" prop="dong_ho_id">
                <el-select
                  v-model="mData.dataForm.dong_ho_id"
                  filterable
                  :disabled="
                    mData.viewMode == 'detail' || mData.viewMode == 'update'
                  "
                  placeholder="Chọn tên dòng họ"
                  tabindex="2"
                >
                  <el-option
                    v-for="item in ten_dong_ho"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>

              <el-form-item label="Thêm ảnh">
                <div class="image-zone">
                  <div
                    class="image-btn"
                    v-show="!mData.dataForm.anh_show"
                    :class="{ deactiveBtn: mData.viewMode == 'detail' }"
                  >
                    <label for="uploadImage">
                      <i class="fas fa-plus-square"></i>
                      Chọn ảnh tải lên</label
                    >
                    <input
                      type="file"
                      id="uploadImage"
                      style="display: none"
                      accept=".jpg, .png, .jpeg"
                      @change="fn_uploadImage"
                      @click="fn_onInputClick"
                      :disabled="mData.viewMode == 'detail'"
                    />
                  </div>
                  <div class="image-show">
                    <img
                      width="100%"
                      :src="mData.dataForm.anh_url"
                      v-show="mData.dataForm.anh_show"
                      alt="ảnh thông báo"
                    />
                    <el-button
                      type="danger"
                      icon="el-icon-delete"
                      style="display: none"
                      @click="fn_remove()"
                      v-if="mData.viewMode !== 'detail'"
                    ></el-button>
                  </div>
                </div>
              </el-form-item>
            </b-col>
          </b-row>

          <div class="text-center mt-3">
            <el-button
              type="danger"
              plain
              @click="fn_cancel()"
              v-ladda
              v-if="mData.viewMode === 'update' || mData.viewMode === 'create'"
              >hủy</el-button
            >
            <el-button
              type="primary"
              @click="fn_addAssess()"
              v-ladda
              v-if="mData.viewMode === 'create'"
              >thêm mới</el-button
            >
            <el-button
              type="primary"
              @click="fn_update()"
              v-ladda
              v-if="mData.viewMode === 'update'"
              >cập nhật</el-button
            >
            <el-button
              type="primary"
              @click="fn_back()"
              v-ladda
              v-if="mData.viewMode === 'detail'"
              >quay lại</el-button
            >
          </div>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
import mushroom from "viettoc-api";
import ValidService from "../../../service/ValidService";
import MethodService from "../../../service/MethodService";
import LanguageService from "../../../service/LanguageService";
import CategoryModel from "../../../views/admin/GeneralDirector/CategoryModel";
import DataForm from "../../../dataForm/dataFormThongBao";
import Media from "@dongido/vue-viaudio";
import { Circle4 } from "vue-loading-spinner";
export default {
  components: {
    Media,
    Circle4,
  },
  data() {
    return {
      aLang: LanguageService.lang,
      ten_dong_ho: [],
      imageSpin: false,
      loading: true,
      mData: {
        viewMode: "create",
        dataForm: MethodService.copyObject(DataForm.dataForm),
        tableRules: MethodService.copyObject(CategoryModel.tableRules),
        validForm: {
          title: [ValidService.required],
          message: [ValidService.required],
          dong_ho_id: [ValidService.required],
          schedule: [ValidService.required],
        },
      },
    };
  },
  methods: {
    // lấy số lượng tối đa đánh giá để trường thu_tu tự động +1 khi tạo đánh giá mới thành công

    async fn_initForm() {
      try {
        const response = await mushroom.notification_queue.findByIdAsync({
          id: this.$router.currentRoute.params.id,
          fields:
            "id,status,source,fromUserId,dong_ho_id,title,message,priority,schedule,imageId,createdTime",
        });
        this.mData.dataForm = response.result;

        console.log("đánh giá chi tiết:", this.mData.dataForm);

        // kiểm tra có id của ảnh, video rồi mới đẩy dữ liệu
        if (this.mData.dataForm.imageId) {
          this.mData.dataForm.anh_url = mushroom.$file.linkBuilder.thumb
            .id(this.mData.dataForm.imageId)
            .build();
          this.mData.dataForm.anh_show = true;
          this.mData.viewMode === "update"
            ? (this.mData.dataForm.anh_btn_show = true)
            : (this.mData.dataForm.anh_btn_show = false);
        }
        this.loading = false;
      } catch (e) {
        console.error("Có lỗi: %o", e);
      }
    },
    // thêm thông báo mới
    async fn_getTenDongHo() {
      const response = await mushroom.dong_ho.listAsync({
        limit: 1000,
        sort: "-thoi_diem_tao",
      });
      response.result.forEach((item) => {
        this.ten_dong_ho.push({
          value: item.id,
          label: item.ten,
        });
      });
    },
    async fn_addAssess() {
      const notification_queue_object = {
        dong_ho_id: this.mData.dataForm.dong_ho_id,
        title: this.mData.dataForm.title,
        message: this.mData.dataForm.message,
        schedule: this.mData.dataForm.schedule,
        imageId: this.mData.dataForm.imageId,
      };
      this.$refs["myForm"].validate(async (valid) => {
        if (valid) {
          try {
            await mushroom.notification_queue.createAsync(
              notification_queue_object
            );
            MethodService.stopLadda();
            this.fn_resetForm();
            this.fn_resetDataForm();
            console.log(notification_queue_object);
            window.toastr.success("Thêm mới đánh giá thành công");

            this.$router.push({
              name: "DanhSachThongBao",
            });
          } catch (error) {
            console.log(error);
            console.log(this.$refs.myForm.$el);
            if (error.code === 4) {
              window.toastr.error(this.aLang.no_server);
            } else if (error.code === 2) {
              window.toastr.error("Gặp sự cố tải dữ liệu");
            } else {
              window.toastr.error("Đã có lỗi xảy ra");
            }
          }
        } else {
          MethodService.stopLadda();
        }
      });
    },
    fn_hideAssess() {
      console.log("change");
      this.hideAssess = !this.hideAssess;
      this.mData.dataForm.hien_thi.an = this.hideAssess;
    },

    // thao tác ảnh
    async fn_uploadImage() {
      this.imageSpin = true;
      try {
        let nameImage = document.getElementById("uploadImage").files[0].name;
        let typeImage = nameImage.slice(nameImage.indexOf("."));
        if (
          typeImage != ".jpg" &&
          typeImage != ".png" &&
          typeImage != ".jpeg"
        ) {
          console.log("định dạng file:", typeImage);
          window.toastr.warning("Vui lòng chọn đúng định dạng file ảnh");
        } else {
          let res = await mushroom.$file.uploadAsync({
            file: document.getElementById("uploadImage").files[0], // required
          });
          this.imageSpin = false;
          console.log("image: ", res.result);
          this.$forceUpdate();
          this.mData.dataForm.imageId = res.result;
          this.mData.dataForm.anh_show = true;
          this.mData.dataForm.anh_url = mushroom.$file.linkBuilder.thumb
            .id(res.result)
            .build();
          this.mData.dataForm.anh_btn_show = true;
        }
      } catch (error) {
        console.log(error);
        if (error.code === 4) {
          window.toastr.error(this.aLang.no_server);
        } else if (error.code === 2) {
          window.toastr.error("Gặp sự cố tải dữ liệu");
        } else {
          window.toastr.error("Đã có lỗi xảy ra");
        }
      }
    },

    // thao tác video

    // xóa ảnh và video vừa upload
    fn_remove() {
      this.mData.dataForm.anh_show = false;
      this.mData.dataForm.anh_url = "";
      this.mData.dataForm.imageId = "";
      //this.mData.dataForm.anh_btn_show = false;

      this.$forceUpdate();
    },

    // reset lại thẻ input khi vừa xóa ảnh/video
    fn_onInputClick(event) {
      event.target.value = "";
    },

    // cập nhật đánh giá
    async fn_update() {
      const notification_queue_object = {
        id: this.$router.currentRoute.params.id,
        title: this.mData.dataForm.title,
        message: this.mData.dataForm.message,
        schedule: this.mData.dataForm.schedule,
        imageId: this.mData.dataForm.imageId,
      };
      console.log("đánh giá cập nhật:", notification_queue_object);
      try {
        // cập nhật thứ tự mới cho đánh giá đang thao tác cập nhật
        const response = await mushroom.notification_queue.partialUpdateAsync(
          notification_queue_object
        );
        if (response.result == this.$router.currentRoute.params.id) {
          window.toastr.success("Cập nhật Slide thành công");
          MethodService.stopLadda();
          this.$router.push({
            name: "DanhSachThongBao",
          });
        } else {
          window.toastr.warning("Dữ liệu không thay đổi");
          MethodService.stopLadda();
        }
      } catch (error) {
        MethodService.stopLadda();
        console.error("Có lỗi: %o", error);
        if (e.code === 4) {
          window.toastr.error(this.aLang.no_server);
        } else if (e.code === 2) {
          window.toastr.error("Máy chủ không phản hồi");
        }
      }
    },

    // quay lại danh sách đánh giá
    fn_back() {
      this.$router.go(-1);
    },

    // reset form
    fn_resetForm() {
      this.$refs.myForm.$el.reset();
    },
    fn_resetDataForm() {},
    fn_cancel() {
      this.fn_resetForm();
      this.fn_resetDataForm();
      this.$router.go(-1);
    },
    forceUpdateUI() {
      this.$forceUpdate();
    },
  },

  async created() {
    await this.fn_getTenDongHo();
    // kiểm tra loại viewMode
    console.log(this.$router.currentRoute.name);
    if (this.$router.currentRoute.name == "ThemMoiThongBao") {
      this.mData.viewMode = "create";
      this.loading = false;
    }
    if (this.$router.currentRoute.name == "ChiTietThongBao") {
      this.mData.viewMode = "detail";
      await this.fn_initForm();
    }
    if (this.$router.currentRoute.name == "CapNhatThongBao") {
      this.mData.viewMode = "update";
      await this.fn_initForm();
    }
  },
};
</script>

<style lang="scss" scoped>
::v-deep .slideText textarea {
  height: 111px;
}
label {
  margin-bottom: 0;
}
.uploadImage {
  position: relative;
}

::v-deep .el-upload--text {
  display: none;
}
::v-deep .flower-spinner {
  background-color: transparent;
}
.image-btn {
  padding: 0px 5px;
  border: 1px solid #b3d8ff;
  border-radius: 3px;
  width: fit-content;

  color: #3b5dbf;
  background-color: #ecf5ff;
  transition: 0.3s;
  font-size: 13px;
  &:hover {
    background-color: #409eff;
    color: #fff;
  }
  label {
    cursor: pointer;
  }
  i {
    margin-right: 5px;
  }
}
.image-zone {
  border: 1px dashed #409eff;
  border-radius: 5px;
  padding: 5px;
  height: 290px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.image-show {
  position: relative;
  button {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  img {
    max-height: 200px;
  }
  img,
  .el-button--danger {
    transition: 0.3s;
  }
  &:hover img {
    opacity: 0.8;
  }
  &:hover .el-button--danger {
    display: block !important;
  }
}
.image-btn {
  padding: 0px 5px;
  border: 1px solid #b3d8ff;
  border-radius: 3px;
  width: fit-content;

  color: #3b5dbf;
  background-color: #ecf5ff;
  transition: 0.3s;
  font-size: 13px;
  &:hover {
    background-color: #409eff;
    color: #fff;
  }
  label {
    cursor: pointer;
  }
  i {
    margin-right: 5px;
  }
}

.deactiveBtn {
  border: 1px solid #d3d4d6;
  background-color: #f4f4f5;
  color: rgb(109, 109, 109);
  &:hover {
    background-color: #f4f4f5;
    color: rgb(109, 109, 109);
  }
  label,
  i {
    cursor: no-drop;
  }
}
</style>
